import { Attachment } from "airtable"
import ReactMarkdown from "react-markdown"
import tw from "twin.macro"
import { ContentDataProps } from "../../pages/[parent]"
import { StyledBodyText } from "../bodyText"
import { ExhibitionImage } from "../exhibitions"

interface CardProps {
  body: string
  year: string
  image_url: string
  image_preview: Array<Attachment>
  caption: string
}
const Card = (props: CardProps) => {
  const { body, image_url, image_preview, caption } = props
  const captionText = caption ? caption.toString() : ""
  const bodyText = body ? body.toString() : ""
  return (
    <div>
      {image_url && (
        <ExhibitionImage image_url={image_url.toString()} image_preview={image_preview} caption={captionText} />
      )}
      <StyledBodyText>
        <ReactMarkdown>{bodyText}</ReactMarkdown>
      </StyledBodyText>
    </div>
  )
}

const Collections = (props: ContentDataProps) => {
  const { contentData } = props

  return (
    <div tw="max-w-screen-desktop-lg desktop-lg:mx-auto px-4 relative">
      <div tw="grid grid-cols-4 desktop:(grid-cols-12) gap-4 desktop:(gap-6)">
        <div tw="col-span-4 tablet:(col-span-4) tablet-lg:(col-span-8)">
          <StyledBodyText>
            {contentData.map((item: any, i: number) => {
              return <Card {...item.fields} key={i} />
            })}
          </StyledBodyText>
        </div>
      </div>
    </div>
  )
}

export default Collections
